import { Form, Head } from "@inertiajs/react"

import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import AppLayout from "@/layouts/app-layout"
import { adminPropertiesPath, newAdminPropertyPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Properties", href: adminPropertiesPath() },
  { title: "New Property", href: newAdminPropertyPath() },
]

export default function New() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Property" />

      <div className="max-w-2xl space-y-6 p-6">
        <div>
          <h1 className="text-2xl font-semibold">New Property</h1>
          <p className="text-muted-foreground text-sm">Add a new property to your portfolio.</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Property Details</CardTitle>
          </CardHeader>
          <CardContent>
            <Form method="post" action={adminPropertiesPath()} className="space-y-4">
              {({ errors, processing }) => (
                <>
                  <div className="grid gap-2">
                    <Label htmlFor="name">Property Name</Label>
                    <Input id="name" name="name" placeholder="e.g. Treystar Tower" />
                    <InputError messages={errors.name} />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="address">Address</Label>
                    <Input id="address" name="address" placeholder="123 Main St" />
                    <InputError messages={errors.address} />
                  </div>

                  <div className="grid grid-cols-3 gap-3">
                    <div className="col-span-1 grid gap-2">
                      <Label htmlFor="city">City</Label>
                      <Input id="city" name="city" placeholder="City" />
                      <InputError messages={errors.city} />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="state">State</Label>
                      <Input id="state" name="state" placeholder="State" maxLength={2} />
                      <InputError messages={errors.state} />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="zip_code">ZIP Code</Label>
                      <Input id="zip_code" name="zip_code" placeholder="ZIP" />
                      <InputError messages={errors.zip_code} />
                    </div>
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="description">Description</Label>
                    <Textarea id="description" name="description" placeholder="Optional description..." rows={4} />
                    <InputError messages={errors.description} />
                  </div>

                  <div className="flex gap-3 pt-2">
                    <Button type="submit" disabled={processing}>Create Property</Button>
                    <Button variant="outline" type="button" onClick={() => history.back()}>
                      Cancel
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  )
}
